export default __webpack_public_path__ + "static/media/folder.ba91bfe5.svg";